// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notification-setting-tab[data-v-81ba91e6]{width:100%;overflow:auto}.notification-setting-tab .box-footer[data-v-81ba91e6]{padding:10px 0 0 0!important}.notification-setting-tab .update-btn[data-v-81ba91e6]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
